export const SVG_TYPES = {
	SHAPE: 'shape',
	TINT: 'tint',
	COLOR: 'color',
	UGC: 'ugc',
} as const

export const SVG_ID_ATTRIBUTE = 'wixshapeid' as const
